import _ from 'lodash-es';
import templateModalKform from '~/components/kform/modal/modal-kform.html';
import ModalKformController from '~/components/kform/modal/modal-kform.controller';
import UploadClassicBlockController from '../upload-classic-block/upload-classic-block.controller';

export default class UploadClassicLinksController {
	/* @ngInject */
	/**
	 * @param {import('angular').IFilterService} $filter
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} NodeService
	 */
	constructor(
		$filter,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		NodeService,
	) {
		this.$filter = $filter;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.NodeService = NodeService;

		/** @type {?UploadClassicBlockController} */
		this.block = null;

		this.booleanItems = [
			{
				kid:   'K_NODE;TRUE',
				name:  'common.yes',
				value: true,
			},
			{
				kid:   'K_NODE;FALSE',
				name:  'common.no',
				value: false,
			},
		];

		/** @type {any} */
		this.datePickerOptions = {
			allowInput:   true,
			dateFormat:   'd/m/Y',
			displayInput: true,
			placeholder:  'JJ/MM/AAAA',
			static:       true,
			time_24hr:    true,
		};

		this.maskOptions = {
			format:             Number,
			mapToRadix:         ['.'],
			max:                100_000,
			min:                -100_000,
			normalizeZeros:     true,
			radix:              ',',
			scale:              2,
			thousandsSeparator: ' ',
		};

		this.error = undefined;
		this.file = undefined;
		this.form = undefined;

		/** @type {number} */
		this.index = -1;

		/** @type {any[]} */
		this.links = [];

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		/** @type {any} */
		this.tmp = {
			ctx: {},
		};
	}

	$onInit() {
		this.file = this.block?.files[this.index];
		this.$scope.$watch('$ctrl.block.files[index].isa', () => {
			this.file = this.block?.files[this.index];
			this.ngModelCtrl?.$validate();
		});

		this.$scope.$watch('$ctrl.block.files[$ctrl.index].minLinks', () => {
			this.$timeout(() => {
				if (!Array.isArray(this.links)) {
					this.links = [];
				}
			});
			this.ngModelCtrl?.$validate();
		});

		this.$scope.$watch('$ctrl.links', () => {
			this.ngModelCtrl?.$validate();
		}, true);

		if (this.ngModelCtrl) {
			this.ngModelCtrl.$validators.required = () => {
				let valid = true;

				if (this.file?.ctxs) {
					for (const context of this.file.ctxs) {
						const links = this.links.filter(
							l => l.class_kid === context.node && l.linker_kid === context.linker_kid,
						);
						if (links.length < context.card.from || links > context.card.to) {
							valid = false;
						}
					}
				}

				this.$timeout(() => {
					this.error = !valid;
				});
				return valid;
			};
		}

		if (this.block?.options.links) {
			for (const item of this.block.options.links) {
				item.readonly = true;
				(async () => this.addLink(item, true))();
			}
		}
	}

	/**
	 * @param {any} link
	 * @param {boolean} user
	 */
	async addLink(link, user) {
		if ((await this.file?.addLink(link)) && user && this.block) {
			if (this.index === 0) {
				for (const [k, file2] of this.block.files.entries()) {
					if (file2.sync && k !== 0) {
						await file2.addLink(link);
					}
				}
			}
			else if (!_.isEqual(this.block.files[this.index].links, this.block.files[0].links)) {
				this.block.files[this.index].sync = false;
			}
		}

		this.$timeout(() => {
			if (link) {
				this.tmp.ctx[`${link.class_kid}|${link.linker_kid}`] = undefined;
			}
			this.$scope.$apply();
		});
	}

	/**
	 * @param {any} item
	 * @param {import('@knitiv/api-client-javascript').TypeKid} type
	 * @returns {any}
	 */
	addTypeToItem(item, type) {
		return {
			...item,
			type_kid: type,
		};
	}

	/**
	 * @param {any} context
	 * @param {string} name
	 * @param {boolean} user
	 */
	async createNode(context, name, user) {
		const nodeDefinition = await this.NodeService.loadDef(context.node);

		try {
			const result = nodeDefinition.lastForm ? { name } : await this.$uibModal.open({
				ariaLabelledBy:  'modal-kform-title',
				ariaDescribedBy: 'modal-kform-body',
				template:        templateModalKform,
				controller:      ModalKformController,
				controllerAs:    '$ctrl',
				size:            'lg',
				resolve:         {
					isa:     () => context.node,
					isaName: () => context.placeholder,
					query:   () => name,
				},
			}).result;

			context.kid = result.kid;

			await this.addLink({
				class_kid:   context.node,
				isa:         context.node,
				isa_name:    context.placeholder,
				kid:         context.kid,
				linker_kid:  context.linker_kid,
				linker_info: context.linker_info,
				name,
				type_kid:    context.type,
			}, user);
		}
		catch (error) {
			if (error !== 'cancel') {
				console.error(error);
			}
			this.$timeout(() => {
				this.tmp.ctx[`${context.node}|${context.linker_kid}`] = undefined;
				this.$scope.$apply();
			});
		}
	}

	/**
	 * @param {Event} event
	 * @param {any} link
	 */
	async removeLink(event, link) {
		await this.file?.removeLink(link);

		if (event && this.block) {
			if (this.index === 0) {
				// Propagation to other links
				for (const [index, file2] of this.block.files.entries()) {
					if (file2.sync && index !== 0) {
						await file2.removeLink(link);
					}
				}
			}
			else if (!_.isEqual(this.block.files[this.index].links, this.block.files[0].links)) {
				this.block.files[this.index].sync = false;
			}
		}

		this.$timeout(() => {
			if (!Array.isArray(this.links)) {
				this.links = [];
			}
		});

		this.ngModelCtrl?.$setDirty();
		this.ngModelCtrl?.$setTouched();
		this.$timeout(() => {
			this.$scope.$apply();
			this.ngModelCtrl?.$validate();
		});
	}

	/**
	 * @param {any} context
	 * @param {any} item
	 * @returns {Promise<void>}
	 */
	async setLinkFromBool(context, item) {
		const link = {
			class_kid:   context.node,
			isa:         context.node,
			isa_name:    context.placeholder,
			kid:         item.kid,
			linker_kid:  context.linker_kid,
			linker_info: context.linker_info,
			name:        this.$translate.instant(item.name),
			type_kid:    context.type,
		};

		const indexLink = this.links.findIndex(l => l.class_kid === link.class_kid
			&& l.isa === link.isa && l.linker_kid === link.linker_kid);

		if (indexLink < 0) {
			await this.addLink(link, true);
		}
		else {
			_.merge(this.links[indexLink], link);
			// this.$timeout(() => {
			// 	this.tmp.ctx[`${link.class_kid}|${link.linker_kid}`] = undefined;
			// 	this.$scope.$apply();
			// });
		}
	}

	/**
	 * @param {any} context
	 */
	async updateDate(context) {
		const date = this.tmp.ctx[`${context.node}|${context.linker_kid}`];

		if (date) {
			const link = {
				class_kid:   context.node,
				isa:         context.node,
				isa_name:    context.placeholder,
				kid:         `K_NODE;${date.replaceAll('-', '').slice(0, 8)}`,
				linker_kid:  context.linker_kid,
				linker_info: context.linker_info,
				name:        new Date(date),
				type_kid:    'K_NODE;DATE',
			};

			const indexLink = this.links.findIndex(l => l.class_kid === link.class_kid
				&& l.isa === link.isa && l.linker_kid === link.linker_kid);

			if (indexLink < 0) {
				await this.addLink(link, true);
			}
			else {
				_.merge(this.links[indexLink], link);
				this.$timeout(() => {
					this.tmp.ctx[`${link.class_kid}|${link.linker_kid}`] = undefined;
					this.$scope.$apply();
				});
			}
		}
	}

	/**
	 * @param {any} context
	 */
	async updateValue(context) {
		const value = this.tmp.ctx[`${context.node}|${context.linker_kid}`];
		if (value !== '') {
			const link = {
				class_kid:   context.node,
				isa:         context.node,
				isa_name:    context.placeholder,
				linker_kid:  context.linker_kid,
				linker_info: context.linker_info,
				name:        value,
				type_kid:    context.type,
			};

			const indexLink = this.links.findIndex(l => l.class_kid === link.class_kid
				&& l.isa === link.isa && l.linker_kid === link.linker_kid);

			if (indexLink < 0) {
				await this.addLink(link, true);
			}
			else {
				_.merge(this.links[indexLink], link);
				this.$timeout(() => {
					this.tmp.ctx[`${link.class_kid}|${link.linker_kid}`] = undefined;
					this.$scope.$apply();
				});
			}
		}
	}
}
